module.exports = __webpack_public_path__ + "img/leakPoint.c4293a24.png";